module.exports = __webpack_public_path__ + "img/haircut.fe642a8c.jpg";